import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 83 83"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#EB5757",
      d: "M70.777 12.144a41.46 41.46 0 1 0-58.634 58.633 41.46 41.46 0 0 0 58.634-58.633ZM41.46 77.364c-19.797 0-35.903-16.106-35.903-35.903 0-19.797 16.106-35.903 35.903-35.903 19.797 0 35.903 16.106 35.903 35.903 0 19.797-16.106 35.903-35.903 35.903Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#EB5757",
      d: "M24.243 20.001 20 24.244l16.97 16.97L20 58.184l4.243 4.243 16.97-16.97 16.97 16.97 4.243-4.242-16.97-16.97 16.97-16.971L58.184 20l-16.97 16.97-16.971-16.97Z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "error"}) } }